module.exports = __webpack_public_path__ + "app/components/users/users.view.html";